<template>
    <div v-show="show">
        <div class="fixed z-40 inset-0 overflow-y-auto overscroll-none">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

                <!--TODO Implement fade transition for background-->
                <div v-show="show" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

                <!--
                  Modal panel, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div
                    class="z-10 inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
                    role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div>
                        <!--Dialog Icon-->
                        <slot name="icon" v-if="showIcon">
                            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                <!-- HeroiconStor name: check -->
                                <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                </svg>
                            </div>
                        </slot>

                        <!-- Title and Subtitle-->
                        <div class="mt-3 text-center md:mt-0">
                            <slot name="title">
                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">{{ title }}</h3>
                            </slot>
                            <slot name="subtitle">
                                <div v-if="subtitle !== null" class="mt-2">
                                    <p class="text-sm leading-5 text-gray-500">
                                        {{ subtitle }}
                                    </p>
                                </div>
                            </slot>
                        </div>

                        <!-- Additional Body content -->
                        <slot name="body"></slot>

                    </div>

                    <!-- Footer & Buttons -->
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2" v-if="showProceedButton">
                            <button type="button" :disabled="proceedDisabled"
                                    @click.prevent="emitProceedEvent"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm  focus:outline-none focus:border-indigo-700 focus:ring focus:ring-indigo-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                    :class="[
                                        showProceedButton ? 'bg-' + proceedButtonColour : '',
                                        showProceedButton && !proceedDisabled ? 'hover:bg-' + proceedButtonHoverColour  : '',
                                        proceedDisabled ? 'opacity-25 cursor-default' : ''
                                    ]">
                                {{ proceedButtonText }}
                            </button>
                        </span>
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1" v-if="showCancelButton">
                            <button type="button"
                                    @click.prevent="emitCancelEvent"
                                    class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                {{ cancelButtonText }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "confirmation-dialog",
    props: {
        show: {
            required: true,
            default: false,
            type: Boolean
        },
        showIcon: {
            required: false,
            default: true,
            type: Boolean
        },
        title: {
            required: true,
            type: String
        },
        subtitle: {
            required: false,
            type: String
        },
        cancelButtonText: {
            required: false,
            type: String,
            default: "Cancel"
        },
        cancelButtonEvent: {
            description: "This is the name of the event that should be emitted when the cancel button is clicked",
            default: "cancelled"
        },
        showCancelButton: {
            required: false,
            type: Boolean,
            default: true,
        },
        proceedButtonText: {
            required: false,
            type: String,
            default: "Proceed"
        },
        proceedButtonColour: {
            required: false,
            type: String,
            default: "indigo-600"
        },
        proceedButtonHoverColour: {
            required: false,
            type: String,
            default: "indigo-800"
        },
        proceedButtonEvent: {
            description: "This is the name of the event that should be emitted when the cancel button is clicked",
            default: "proceed"
        },
        showProceedButton: {
            required: false,
            type: Boolean,
            default: true,
        },
        proceedDisabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        emitCancelEvent () {
            this.$emit(this.cancelButtonEvent);
        },
        emitProceedEvent () {
            this.$emit(this.proceedButtonEvent);
        }
    }
};

</script>

<style scoped>

</style>
